<div class="modal-header border-bottom p-3">
  <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
    {{ "CashMultiPayment" | translate }}
  </h6>
  <button
    type="button"
    class="btn-close-modal btn-icon btn-close"
    aria-label="Close"
    (click)="callParent('closeCredit')"
  ></button>
</div>

<div class="modal-body mx-0 flex-grow-0">
  <div class="add-box-item row p-2">
    <div class="company-selector-box col-12 col-md-6 col-lg-6">
      <label for="companyName" class="form-label m-0"
        >{{ "SelectCompany" | translate }}:</label
      >
      <div class="validation-alert-sale-buy" id="CompanyName">
        <p>{{ backendJson.drugDistributorIdMessage }}</p>
      </div>
      <app-drop-down
        [dropDownData]="companyList"
        [addUrl]="'DrugDistributor'"
        [defaultValue]="this.backendJson.drugDistributorId"
        [isValid]="
          backendJson.drugDistributorIdMessage == '' ||
          backendJson.drugDistributorIdMessage == null
        "
        [buttonClass]="'Focusable'"
        (change)="getFactor()"
        (ngModelValueChange)="changeCompany($event)"
      ></app-drop-down>
    </div>
    <div class="col-12 col-md-6 col-lg-6">
      <label for="cost" class="form-label m-0">
        {{ "PleaseInputCost" | translate }}:</label
      >
      <input
        id="Amount"
        class="form-control"
        type="text"
        [(ngModel)]="paymendAmount"
        mask="separator.0"
        thousandSeparator=","
      />
    </div>
  </div>
  <div class="add-box-item d-flex flex-wrap justify-content-start row mt-3 p-2" *ngIf="factorList && factorList.length > 0">
    <div
      class="p-2 col-12 col-lg-3 col-md-6"
      *ngFor="let item of factorList; let i = index"
    >
      <button
        type="button"
        class="companyName-color"
        [ngClass]="{ 'factor-is-select': item.selected }"
        (click)="selectFactor(item, i)"
      >
        <p>{{ item.factorId | dataType : "" }}</p>
        <p>{{ item.totalPrice | dataType : "price" }}</p>
        <p>{{ item.factorDate | dataType : "" }}</p>
      </button>
    </div>
  </div>
</div>
<div class="modal-footer border-top p-3 justify-content-center">
  <button type="submit" class="btn btn-primary me-sm-3 me-1 data-submit">
    {{ "Submit" | translate }}
  </button>
</div>
